import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgArrowRight = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.2577 12.0437L2 12.0437L2 9.95633L16.2577 9.95633L12.0614 5.47597L13.4438 4L20 11L13.4438 18L12.0614 16.524L16.2577 12.0437Z"
      fill="currentColor"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgArrowRight);

export default ForwardRef;
